// extracted by mini-css-extract-plugin
module.exports = {"aboutPage":"about_aboutPage__6GtEP","banner":"about_banner__23gCI","about":"about_about__A8_rC","title":"about_title__25LXQ","p":"about_p__1ZMae"};